import React, { useState, useEffect, useMemo } from 'react';
import { useCall } from 'contexts/CallContext';
import MiniCallWidget from 'components/leads/LeadActions/MiniCallWidget';
import CallModal from 'components/leads/LeadActions/CallModal';

const GlobalCallWidget = () => {
  const {
    callState,
    callDuration,
    leadData,
    isMuted,
    isRecording,
    shouldShowEndModal,
    isModalOpen,
    toggleMute,
    endCall,
    hideEndModal,
    setModalOpen,
    formatDuration,
    activeProvider,
    setLeadData,
    setOzonetelUcid,
    setActiveProvider
  } = useCall();



  const [showCallModal, setShowCallModal] = useState(false);

  // The key fix: calculate widget visibility with stricter conditions
  const showMiniWidget = useMemo(() => {
    // Rule 1: If any modal is open, never show widget
    if (showCallModal || isModalOpen) {
      return false;
    }

    // Rule 2: Only show if call is active (connected or dialing)
    const isCallActive = callState === 'connected' || callState === 'dialing';
    if (!isCallActive) {
      return false;
    }

    // If both conditions pass, show the widget
    return true;
  }, [callState, showCallModal, isModalOpen]);

  const isWebCall = !activeProvider || (activeProvider !== 'OZONETEL' && activeProvider !== 'CLOUDCONNECT');

  const handleExpandCall = () => {
    if (!isModalOpen) { // Only open if no modal is already open
      setShowCallModal(true);
      setModalOpen(true);
    }
  };

  const handleCloseCallModal = () => {
    setShowCallModal(false);
    setModalOpen(false);
  };

  const handleCallComplete = (callData) => {
    // Here you could save call data to backend
    setShowCallModal(false);
    setModalOpen(false);
    hideEndModal(); // This will reset the call state
  };

  const handleEndCall = () => {
    endCall();
  };

  // Auto-show modal when call ends (only if no modal is already open)
  React.useEffect(() => {
    if (shouldShowEndModal && !showCallModal && !isModalOpen) {
      setShowCallModal(true);
      setModalOpen(true);
    }
  }, [shouldShowEndModal, showCallModal, isModalOpen]);



  return (
    <>
      {/* Mini Call Widget - Global */}
      <MiniCallWidget
        isVisible={showMiniWidget}
        callState={callState}
        callDuration={callDuration}
        leadData={leadData}
        isMuted={isMuted}
        isRecording={isRecording}
        onToggleMute={toggleMute}
        onEndCall={handleEndCall}
        onExpandCall={handleExpandCall}
        formatDuration={formatDuration}
        isWebCall={isWebCall}
      />

      {/* Call Modal - Global */}
      <CallModal
        isOpen={showCallModal}
        onClose={handleCloseCallModal}
        leadData={leadData}
        onCallComplete={handleCallComplete}
      />
    </>
  );
};

export default GlobalCallWidget;
